<template>
    <a-modal v-model:visible="visible" title="编辑商品" width="50%" centered :confirmLoading="loading" @ok="doValidate()">
        <a-form-model ref="formRef" :model="formData" label-position="top">
            <a-row :gutter="12">
                <a-col :span="10">
                    <a-form-model-item label="商品名称" label-position="top" prop="title"
                        :rules="{ required: true, message: '请输入商品名称' }">
                        <a-input v-model="formData.title" placeholder="请输入商品名称" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="所属类别" label-position="top" prop="cateId"
                        :rules="{ required: true, message: '请选择所属类别' }">
                        <a-select v-model="formData.cateId" placeholder="请选择所属类别">
                            <a-select-option :value="item.cateId" v-for="item in category" :key="item.cateId">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col> <a-col :span="8">
                    <a-form-model-item label="所属单位" label-position="top" prop="organId"
                        :rules="{ required: true, message: '请选择所属单位' }">
                        <choose-organ v-model="formData.organId"></choose-organ>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="12">

                <a-col :span="4">
                    <a-form-model-item label="商品类型" label-position="top" prop="goodsType"
                        :rules="{ required: true, message: '请选择商品类型' }">
                        <a-select v-model="formData.goodsType">
                            <a-select-option v-for="(item, index) in goodsType" :value="item.label" :key="index">
                                {{ item.label }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="兑换积分" prop="grade" :rules="{ required: true, message: '请输入兑换积分' }">
                        <a-input-number style="width: 100%;" v-model="formData.grade" :min="1"
                            placeholder="积分数量"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="排序" prop="sort">
                        <a-input-number style="width: 100%;" v-model="formData.sort" :min="0"
                            placeholder="排序值"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="状态" prop="status">
                        <a-radio-group v-model="formData.status" button-style="solid" style="width: 100%;">
                            <a-radio-button value="上架">上架</a-radio-button>
                            <a-radio-button value="下架">下架</a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="可用商户范围" prop="scopeList" help="不选择表示所有商户可用">
                        <choose-store v-model="formData.scopeList" multiple></choose-store>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="12">
                <a-col :span="4">
                    <a-form-model-item label="物品类型" prop="couponType" :rules="{ required: true, message: '请选择物品类型' }">
                        <a-select v-model="formData.couponType" placeholder="请选择类型">
                            <a-select-option v-for="(item, index) in couponType" :value="item.label" :key="index"
                                v-if="item.type == formData.goodsType">
                                {{ item.label }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="面值" prop="money"
                        :rules="{ required: !['折扣券', '礼品'].includes(formData.couponType), message: '请填写面值' }">
                        <a-input-number placeholder="面值" :disabled="['折扣券', '礼品'].includes(formData.couponType)"
                            v-model="formData.money" style="width:100%"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="折扣" prop="discount" help="1-99之间的数字"
                        :rules="{ required: ['折扣券'].includes(formData.couponType), message: '请填写折扣' }">
                        <a-space>
                            <a-input-number placeholder="最大99" :disabled="!['折扣券'].includes(formData.couponType)"
                                v-model="formData.discount" :max="99" :min="1" style="width:100%">
                            </a-input-number>
                            <span>折</span>
                        </a-space>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="使用条件" prop="fullMoney" help="实付金额满多少可用"
                        :rules="{ required: !['礼品'].includes(formData.couponType), message: '请填写使用条件' }">
                        <a-input-number placeholder="满多少可用" :disabled="['礼品'].includes(formData.couponType)"
                            v-model="formData.fullMoney" :min="0" style="width:100%"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="商家出资比例(%)" prop="storeFee"
                        :rules="{ required: true, message: '请填写商家出资比例' }">
                        <a-input-number placeholder="出资比例" v-model="formData.storeFee" style="width:100%" :max="100"
                            :min="0"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="有效天数(天)" prop="expireDay" help="从领取后开始计算"
                        :rules="{ required: true, message: '请填写有效天数' }">
                        <a-input-number placeholder="有效天数" v-model="formData.expireDay" style="width:100%"
                            :min="1"></a-input-number>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="12">
                <a-col :span="12">
                    <a-form-model-item label="商品描述" prop="description">
                        <a-textarea v-model="formData.description"></a-textarea>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="" label-position="top" prop="thumb"
                        :rules="{ required: true, message: '请上传商品图片' }">
                        <upload-images v-model="formData.thumb" :size="3"></upload-images>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="12">
                <a-col :span="24">
                    <a-form-model-item label="商品详情" prop="content" label-position="top">
                        <editor v-model="formData.content" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>

<script>
import apiUtils from '@/common/apiUtil'
import utils from '@/common/utils'
import { GOODS_TYPE, COUPON_TYPE } from '@/common/gradeGoods'
import request, { editorUpload } from "@/config/request";
import editor from '@/components/component/editor.vue';
import uploadImages from '@/components/upload-images.vue'
import chooseStore from '@/components/choose-store.vue'
export default {
    components: { editor, uploadImages, chooseStore },
    props: {
        category: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            couponType: COUPON_TYPE,
            goodsType: GOODS_TYPE,
            visible: false,
            loading: false,
            formData: {
                goodsId: '',
                cateId: '',
                goodsType: '实物',
                couponType: '礼品',
                fullMoney: 0,
                money: 0,
                discount: 0,
                storeFee: 100,
                expireDay: 365,
                title: '',
                thumb: [],
                description: '',
                content: '',
                grade: '',
                price: '',
                sort: 0,
                stock: 0,
                status: '上架',
                scopeList: '',
                organId: apiUtils.getDefaultOrganId()
            }
        }
    },
    methods: {
        doValidate() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.loading = true;
                request.post('/platform/grade-mall/goods/save', this.formData).then(res => {
                    console.log(res)
                    utils.success('保存成功').then(() => {
                        this.visible = false;
                        this.$emit('success');
                    });
                }).finally(() => {
                    this.loading = false;
                })
            })
        },
        show(data) {
            this.formData.goodsId = '';
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.$refs.formRef.resetFields();
                if (data) {
                    this.formData = JSON.parse(JSON.stringify(data));
                }
            })
        }
    },
    watch: {
        'formData.goodsType': {
            handler(v) {
                if (v == '实物') {
                    this.$set(this.formData, 'couponType', '礼品');
                } else {
                    this.$set(this.formData, 'couponType', null);
                }
            }
        }
    }
}
</script>

<style></style>